(function () {
  "use strict";

  var loadPromises = new WeakMap();

  function loadStyle(url, marker) {
    if (!url) return Promise.resolve();
    var existing = document.querySelector('link[data-m892-lazy-asset="' + marker + '"]');
    if (existing?.dataset.failed === "true") { existing.remove(); existing = null; }
    if (existing) {
      if (existing.dataset.loaded === "true" || existing.sheet) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
      });
    }

    return new Promise(function (resolve, reject) {
      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      link.dataset.m892LazyAsset = marker;
      link.addEventListener("load", function () {
        link.dataset.loaded = "true";
        resolve();
      }, { once: true });
      link.addEventListener("error", function () { link.dataset.failed = "true"; reject(new Error("Style load failed")); }, { once: true });
      document.head.appendChild(link);
    });
  }

  function loadScript(url, marker) {
    if (!url) return Promise.resolve();
    var existing = document.querySelector('script[data-m892-lazy-asset="' + marker + '"]');
    if (existing?.dataset.failed === "true") { existing.remove(); existing = null; }
    if (existing) {
      if (existing.dataset.loaded === "true") return Promise.resolve();
      return new Promise(function (resolve, reject) {
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
      });
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = url;
      script.defer = true;
      script.dataset.m892LazyAsset = marker;
      script.addEventListener("load", function () {
        script.dataset.loaded = "true";
        resolve();
      }, { once: true });
      script.addEventListener("error", function () { script.dataset.failed = "true"; reject(new Error("Script load failed")); }, { once: true });
      document.head.appendChild(script);
    });
  }

  function setLoading(opener, loading) {
    opener.setAttribute("aria-busy", String(loading));
    opener.disabled = loading;
    var label = opener.querySelector(".m892cov__trigger-action span");
    if (!label) return;
    if (!label.dataset.originalText) label.dataset.originalText = label.textContent;
    label.textContent = loading ? "LÄDT…" : label.dataset.originalText;
  }

  function setLoadError(root, opener) {
    root.dataset.coverageLoadError = "true";
    opener.removeAttribute("aria-busy");
    opener.disabled = false;
    var label = opener.querySelector(".m892cov__trigger-action span");
    if (label) label.textContent = "ERNEUT VERSUCHEN";
    opener.setAttribute(
      "aria-label",
      "Fahrzeugprüfung konnte nicht geladen werden. Zum Wiederholen auswählen."
    );
  }

  function ensureAssets(root, opener) {
    if (root.dataset.coverageAssetsReady === "true") return Promise.resolve();
    if (loadPromises.has(root)) return loadPromises.get(root);

    setLoading(opener, true);
    delete root.dataset.coverageLoadError;

    var promise = Promise.all([
      loadStyle(root.dataset.coverageCssUrl, "de-coverage-css"),
      loadStyle(root.dataset.searchCssUrl, "de-search-css")
    ])
      .then(function () {
        return loadScript(root.dataset.coverageJsUrl, "de-coverage-js");
      })
      .then(function () {
        return loadScript(root.dataset.searchJsUrl, "de-search-js");
      })
      .then(function () {
        root.dataset.coverageAssetsReady = "true";
        setLoading(opener, false);
        opener.removeAttribute("aria-label");
      })
      .catch(function (error) {
        loadPromises.delete(root);
        setLoadError(root, opener);
        throw error;
      });

    loadPromises.set(root, promise);
    return promise;
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-m892-open]");
    if (!opener) return;
    var root = opener.closest('[data-m892-coverage][data-language="DE"][data-lazy-assets="true"]');
    if (!root || root.dataset.coverageAssetsReady === "true") return;

    event.preventDefault();
    event.stopImmediatePropagation();
    ensureAssets(root, opener)
      .then(function () {
        window.requestAnimationFrame(function () {
          opener.focus({ preventScroll: true });
          opener.click();
        });
      })
      .catch(function () {
        // The launcher remains available with an actionable retry label.
      });
  }, true);
})();
